var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"error-con"},[_c('img',{staticClass:"error-tu",attrs:{"src":_vm.imgUrl+'9fe99bf296c4468783afb42f213310fa'}}),_c('p',[_vm._v("您访问的页面不存在...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }